import React from 'react';
import { Icon, Typography } from '@/components/common';
import Icons from '@/const/icons';
import { PdfViewerDownloadControl } from './PdfViewerControls';

interface Props {
	backLabel: string;
	onBack: () => void;
	documentUrl: string;
	fileName?: string;
	downloadDisabled?: boolean;
}

export const ReplyPanelHeader: React.FC<Props> = ({
	backLabel,
	onBack,
	documentUrl,
	fileName,
	downloadDisabled,
}) => (
	<div className="flex items-center justify-between pb-4">
		<button
			type="button"
			onClick={onBack}
			className="flex items-center gap-2 text-sm font-medium hover:opacity-70 transition-opacity"
		>
			<Icon src={Icons.arrowLeft} width={18} height={18} />
			<Typography type="semibold-16">{backLabel}</Typography>
		</button>
		<PdfViewerDownloadControl
			documentUrl={documentUrl}
			fileName={fileName}
			disabled={downloadDisabled}
		/>
	</div>
);
